<template>
	<div class="register">
		<infoHeader :title="title" icon="el-icon-s-custom"></infoHeader>
		<div class="fixation">
			<div class="register-form">
				<el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="120px">
					<div class="welcome">
						欢迎注册
					</div>
					<el-form-item label="用户名" prop="account">
						<el-input type="text" v-model.trim="ruleForm.account" placeholder="仅英文字母，最长 14 位，区分大小写"
							maxlength="14" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input type="text" v-model="ruleForm.phone" placeholder="用于登录和找回密码"></el-input>
					</el-form-item>
					<el-form-item label="电子邮箱" prop="email">
						<el-input type="text" v-model="ruleForm.email" placeholder="用于登录和找回密码"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input type="password" v-model.trim="ruleForm.password" placeholder="8–32 位；字母/数字/符号(!@#$%^&*)至少两类"
							maxlength="32" show-password autocomplete="new-password"
							:disabled="isRegisterPwdLocked"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="rptpassword">
						<el-input type="password" v-model.trim="ruleForm.rptpassword" placeholder="请再次输入密码"
							maxlength="32" show-password autocomplete="new-password"
							:disabled="isRegisterPwdLocked"></el-input>
					</el-form-item>
					<!-- 同一用户名维度：密码规则提交失败计数与 10 分钟锁定提示（状态在本地 localStorage，防跨浏览器需后端限流） -->
					<div v-if="ruleForm.account" class="register-pwd-lock-wrap">
						<div class="register-pwd-lock-panel">
							<p v-if="isRegisterPwdLocked" class="lock-line">
								<i class="el-icon-lock"></i>
								密码不符合规则已连续提交失败 {{ pwdLockMaxFails }} 次，已锁定 {{ pwdLockMinutes }} 分钟。
								剩余：<strong>{{ registerPwdLockCountdownText }}</strong>
								<span v-if="pwdLockSnapshot.lifetimeLockCount" class="lock-meta">（该用户名历史累计锁定
									{{ pwdLockSnapshot.lifetimeLockCount }} 次）</span>
							</p>
							<p v-else-if="pwdLockSnapshot.fails > 0" class="warn-line">
								<i class="el-icon-warning"></i>
								密码规则校验已失败 {{ pwdLockSnapshot.fails }} 次，
								剩余可尝试 <strong>{{ pwdLockSnapshot.remainingAttempts }}</strong> 次；
								达到 {{ pwdLockMaxFails }} 次将锁定 {{ pwdLockMinutes }} 分钟。
								<span v-if="pwdLockSnapshot.lifetimeLockCount" class="lock-meta">（历史累计锁定
									{{ pwdLockSnapshot.lifetimeLockCount }} 次）</span>
							</p>
							<p v-else class="tip-line">
								<i class="el-icon-info"></i>
								密码不符合规则时，同一用户名连续提交失败 {{ pwdLockMaxFails }} 次将锁定 {{ pwdLockMinutes }} 分钟。
							</p>
						</div>
					</div>
					<el-form-item label="验证方式" prop="type">
						<el-select v-model="ruleForm.type" placeholder="请选择验证方式">
							<el-option v-for="(item,index) in typeList" :label="item.label" :value="item.value"
								:key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="验证码" prop="code">
						<el-input type="text" v-model="ruleForm.code" placeholder="请输入验证码">
							<el-button slot="append" :disabled="disabled" :loading="loading" @click="sendCode">
								<span v-if="!disabled">发送{{ruleForm.type==1?'短信':'邮箱'}}验证码</span>
								<span v-else>{{second}}秒后可重发</span>
							</el-button>
						</el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="danger" plain @click="resetForm('ruleForm')">重置</el-button>
							<el-button type="danger" :loading="loading" :disabled="isRegisterPwdLocked"
								@click="submitForm('ruleForm')">注册</el-button>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="dialog-agreement">
							<el-checkbox v-model="checked"></el-checkbox>阅读并接受<router-link :to="{
								path:'/agreement',
								query:{
									id:'1961d643e0dc4c83b98b005eb7e8303b'
								}
							}">用户协议</router-link>及
							<router-link :to="{
								path:'/agreement',
								query:{
									id:'72beccc591c349528934ff34b832befb'
								}
							}">隐私政策</router-link>
						</div>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog :visible="successDialog" :show-close="false" top="280px" width="600px">
			<div class="login-dialog-title">
				<i class="el-icon-circle-check"></i>注册成功
			</div>
			<div class="button">
				<el-button @click="closeSuccess, goIndex()" plain type="danger" round>返回首页</el-button>
				<el-button @click="doLogin" type="danger" round>直接登录</el-button>
			</div>
		</el-dialog>
		<pubfooter></pubfooter>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	import {
		getRegisterPwdLockInfo,
		recordRegisterPwdFailure,
		clearRegisterPwdFailures,
		REGISTER_PWD_MAX_FAILS,
		REGISTER_PWD_LOCK_MS
	} from '../../utils/registerPasswordLock.js'

	export default {
		name: 'register',
		data() {
			// 注册页专用：与全局 verify_password 分离，避免影响登录/管理端
			let verify_account = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterUsernameError(value)
				if (msg) callback(new Error(msg))
				else callback()
			}
			let verify_password = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterPasswordError(value)
				if (msg) callback(new Error(msg))
				else callback()
			}
			let verify_rptpassword = (rule, value, callback) => {
				if (!value) {
					callback()
					return
				}
				const msg = this.$ver.getRegisterPasswordError(value)
				if (msg) {
					callback(new Error(msg))
					return
				}
				if (this.ruleForm.password !== value) {
					callback(new Error('两次输入的密码不一致'))
					return
				}
				callback()
			}
			let verify_phone = (rule, value, callback) => {
				if (!this.$ver.verify_phone(this.ruleForm.phone)) {
					callback(new Error('手机号格式错误'))
				} else {
					callback()
				}
			}
			let verify_email = (rule, value, callback) => {
				if (!this.$ver.verify_email(this.ruleForm.email)) {
					callback(new Error('邮箱格式错误'))
				} else {
					callback()
				}
			}
			return {
				title: '注册账号',
				ruleForm: {
					account: '',
					phone: '',
					email: '',
					password: '',
					rptpassword: '',
					code: '',
					type: 1
				},
				typeList: [{
						label: '手机短信验证',
						value: 1
					},
					{
						label: '邮箱验证',
						value: 2
					}
				],
				rule: {
					account: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请输入用户名'
					}, {
						validator: verify_account,
						trigger: ['blur', 'change']
					}],
					password: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请输入密码'
					}, {
						validator: verify_password,
						trigger: ['blur', 'change']
					}],
					phone: [{
						required: true,
						trigger: 'blur',
						validator: verify_phone
					}],
					email: [{
						required: true,
						trigger: 'blur',
						validator: verify_email
					}],
					rptpassword: [{
						required: true,
						trigger: ['blur', 'change'],
						message: '请确认密码'
					}, {
						validator: verify_rptpassword,
						trigger: ['blur', 'change']
					}],
					type: [{
						required: true,
						trigger: 'change',
						message: '请选择验证方式'
					}],
					code: [{
						required: true,
						trigger: 'blur',
						message: '请输入短信验证码'
					}]
				},
				checked: false,
				disabled: false,
				successDialog: false,
				loading: false,
				second: 60,
				/** 与 utils 一致，供模板展示「多少次后锁定」 */
				pwdLockMaxFails: REGISTER_PWD_MAX_FAILS,
				/** 锁定总时长（分钟），仅用于提示文案 */
				pwdLockMinutes: REGISTER_PWD_LOCK_MS / 60000,
				/**
				 * 当前用户名下密码规则失败的本地快照（详见 registerPasswordLock.js）
				 * 跨浏览器不可替代服务端限流
				 */
				pwdLockSnapshot: getRegisterPwdLockInfo('')
			};
		},
		computed: {
			/** 是否处于「密码规则失败过多」锁定期，用于禁用密码项与注册按钮 */
			isRegisterPwdLocked() {
				return this.pwdLockSnapshot.locked === true
			},
			/** 锁定剩余时间展示（依赖定时器刷新 pwdLockSnapshot） */
			registerPwdLockCountdownText() {
				const ms = this.pwdLockSnapshot.lockEndsIn
				if (!this.isRegisterPwdLocked || ms <= 0) return ''
				const s = Math.ceil(ms / 1000)
				const m = Math.floor(s / 60)
				const sec = s % 60
				return `${m} 分 ${String(sec).padStart(2, '0')} 秒`
			}
		},
		watch: {
			// 修改密码后同步复验确认密码，避免仍显示「一致」旧状态
			'ruleForm.password'() {
				if (this.ruleForm.rptpassword && this.$refs.ruleForm) {
					this.$refs.ruleForm.validateField('rptpassword')
				}
			},
			/** 切换注册用户名时，切换对应的失败/锁定状态 */
			'ruleForm.account'() {
				this.$nextTick(() => this.syncPwdLockFromStorage())
			}
		},
		methods: {
			...mapMutations(['login', 'saveUserinfo']),
			/** 从本地存储同步当前用户名的锁定/失败次数（供模板与提交前校验） */
			syncPwdLockFromStorage() {
				const acc = (this.ruleForm.account || '').trim()
				this.pwdLockSnapshot = getRegisterPwdLockInfo(acc)
			},
			resetForm(formName) {
				this.$refs[formName].resetFields()
			},
			sendCode() {
				if (this.disabled) return
				if (this.ruleForm.type == 1) {
					if (this.ruleForm.phone == '') {
						this.$message({
							message: '请输入手机号',
							type: 'error',
							duration: 2000
						})
						return
					}
					this.loading = true
					this.$api.frontSendMsg({
						phone: this.ruleForm.phone,
						scence: 0,
						userId: '',
						username: ''
					}, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '短信验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				} else {
					if (this.ruleForm.email == '') {
						this.$message({
							message: '请输入邮箱地址',
							type: 'error',
							duration: 2000
						})
						return
					}
					this.loading = true
					this.$api.frontSendEmail({
						email: this.ruleForm.email,
						scence: 0,
						userId: '',
						username: ''
					}, res => {
						this.loading = false
						if (res.code == 200) {
							this.$message({
								message: '邮箱验证码发送成功。',
								type: 'success',
								duration: 2000
							})
							this.timer()
						}
					})
				}
			},
			timer() {
				this.disabled = true
				this.$pub.timer(this.second, res => {
					this.second = res
					if (res == 0) {
						this.second = 60
						this.disabled = false
					}
				})
			},
			submitForm(formName) {
				if (!this.checked) {
					this.$message({
						message: '请阅读《用户协议》与《隐私政策》后再继续。',
						type: 'error',
						duration: 2000
					})
					return
				}
				// 密码规则失败锁定：先拦截，避免继续走表单项校验消耗用户心智
				this.syncPwdLockFromStorage()
				if (this.isRegisterPwdLocked) {
					this.$message({
						message: `密码校验失败次数过多，已锁定 ${this.pwdLockMinutes} 分钟，剩余 ${this.registerPwdLockCountdownText} 后可再试`,
						type: 'error',
						duration: 4000
					})
					return
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.frontRegister({
							username: this.ruleForm.account,
							phone: this.ruleForm.phone,
							email: this.ruleForm.email,
							pwd: this.ruleForm.password,
							rePassword: this.ruleForm.rptpassword,
							codeType: this.ruleForm.type,
							code: this.ruleForm.code
						}, res => {
							if (res.code == 200) {
								// 注册成功：清除该用户名下本地失败计数，避免影响后续同一浏览器会话
								clearRegisterPwdFailures(this.ruleForm.account)
								this.syncPwdLockFromStorage()
								this.successDialog = true
							}
						})
					} else {
						// 仅在「密码/确认密码相对规则不合法或不一致」时累计失败次数，避免手机号等其它项报错误伤
						const acc = (this.ruleForm.account || '').trim()
						const p = this.ruleForm.password
						const r = this.ruleForm.rptpassword
						const pwdBad = !!(
							this.$ver.getRegisterPasswordError(p) ||
							this.$ver.getRegisterPasswordError(r) ||
							(p !== r)
						)
						if (pwdBad && acc) {
							this.pwdLockSnapshot = recordRegisterPwdFailure(acc)
							if (this.pwdLockSnapshot.locked) {
								this.$message({
									message: `密码不符合规则已连续失败 ${this.pwdLockMaxFails} 次，已锁定 ${this.pwdLockMinutes} 分钟`,
									type: 'error',
									duration: 4000
								})
							} else {
								this.$message({
									message: `密码不符合规则，剩余可尝试次数：${this.pwdLockSnapshot.remainingAttempts}（达 ${this.pwdLockMaxFails} 次将锁定 ${this.pwdLockMinutes} 分钟）`,
									type: 'warning',
									duration: 3200
								})
							}
							this.$nextTick(() => {
								if (this.$refs[formName]) {
									this.$refs[formName].validateField('password')
									this.$refs[formName].validateField('rptpassword')
								}
							})
						}
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeSuccess() {
				this.successDialog = false
			},
			doLogin() {
				this.closeSuccess()
				this.$api.frontLogin({
					username: this.ruleForm.account,
					pwd: this.ruleForm.password
				}, res => {
					if (res.code == 200) {
						this.saveUserinfo(res.data.systemUser)
						this.login(res.data.token)
						let t = res.data.systemUser.authentication == 0 ? 1 : 3
						this.goIndex(t)
						// this.login('1a2b3c4d5e6f')
						// this.saveUserinfo({
						// 	name: '叶芊萍',
						// 	realFlag: false,
						// 	avatar: require('../../assets/touxiang.jpg')
						// })

					}
				})
			},
			goIndex(t) {
				sessionStorage.setItem('realname', t)
				this.$router.push({
					path: '/'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			// 进入页面时拉取一次锁定状态；锁定期间用定时器刷新剩余时间文案
			this.syncPwdLockFromStorage()
			this._registerPwdLockTimer = setInterval(() => {
				if (this.isRegisterPwdLocked) {
					this.syncPwdLockFromStorage()
				}
			}, 1000)
		},
		beforeDestroy: function() {
			if (this._registerPwdLockTimer) {
				clearInterval(this._registerPwdLockTimer)
				this._registerPwdLockTimer = null
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.fixation {
		display: flex;
		justify-content: center;
		padding: @vue-spacing-col-lg*2 0px;
	}

	.login-dialog-title {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		font-size: @vue-font-size-lg;
		color: @vue-text-color-red;

		i {
			margin-top: @vue-spacing-col-sm;
			margin-right: @vue-spacing-row-sm;
		}
	}

	.el-select {
		width: 100%;
	}

	/* 与 el-form label-width=120px 对齐 */
	.register-pwd-lock-wrap {
		margin-left: 120px;
		margin-bottom: 8px;
		max-width: 520px;
	}

	.register-pwd-lock-panel {
		font-size: 13px;
		line-height: 1.55;
		color: @vue-text-color-darkgrey;

		p {
			margin: 0 0 6px 0;
		}

		i {
			margin-right: 6px;
		}

		.tip-line {
			color: @vue-text-color-grey;
		}

		.warn-line {
			color: #e6a23c;
		}

		.lock-line {
			color: #f56c6c;
		}

		.lock-meta {
			margin-left: 4px;
			font-size: 12px;
			opacity: 0.9;
		}
	}

	.button {
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: @vue-spacing-col-lg;
	}
</style>
